module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('cover-section'), _vm._v(" "), _c('filters-section'), _vm._v(" "), _c('home-footer', {
    ref: "homeFooter"
  }), _vm._v(" "), (_vm.isFiltered) ? _c('close-button', {
    attrs: {
      "direction": "right"
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetFilter($event)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-798d4ddf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/index.vue
 ** module id = 755
 ** module chunks = 2
 **/